"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
function createPortalContainer(parentTag, parentClassName) {
  var element = document.createElement(parentTag);
  element.className = (0, _classnames["default"])('portal-container', parentClassName);
  return element;
}
function Portal(_ref) {
  var parentTag = _ref.parentTag,
    parentClassName = _ref.parentClassName,
    querySelector = _ref.querySelector,
    children = _ref.children;
  var ref = _react["default"].useRef(createPortalContainer(parentTag, parentClassName));
  _react["default"].useEffect(function () {
    var el = ref.current;
    var targetNode = document.querySelector(querySelector);
    targetNode.appendChild(el);
    return function () {
      return targetNode.removeChild(el);
    };
  }, [ref, querySelector]);
  return /*#__PURE__*/(0, _reactDom.createPortal)(children, ref.current);
}
Portal.displayName = 'Portal';
Portal.defaultProps = {
  parentTag: 'div'
};
Portal.propTypes = {
  parentTag: _propTypes["default"].string,
  parentClassName: _propTypes["default"].string,
  querySelector: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = Portal;